import styled from 'styled-components'

import { ContentExpand } from './ContentExpand'

export const Page = styled(ContentExpand)`
	row-gap: 12px;
`
